import { render, staticRenderFns } from "./PreventionTotal.vue?vue&type=template&id=79ccd181&scoped=true"
import script from "./PreventionTotal.vue?vue&type=script&lang=js"
export * from "./PreventionTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ccd181",
  null
  
)

export default component.exports